import { Announcement, PagedAnnouncement } from "@models";
import { announcementService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class AnnouncementStore {
  announcements: Announcement[] = [];
  latest: Announcement[] = [];
  totalCount = 0;
  skipCount = 0;
  maxResultCount = 4;
  loading = false;
  latestLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async (request: PagedAnnouncement) => {
    this.loading = true;
    try {
      const response = await announcementService.getAll(request);
      runInAction(() => {
        this.announcements = response.items;
        this.totalCount = response.totalCount;
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  getLatest = async (request: PagedAnnouncement) => {
    this.latestLoading = true;
    try {
      const response = await announcementService.getAll(request);
      runInAction(() => {
        this.latest = response.items;
        this.totalCount = response.totalCount;
        this.latestLoading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.latestLoading = false;
      });
    }
  };

  setSkipCount = (value: number) => {
    this.skipCount = value;
  };

  handlePageChange = (page: number) => {
    this.skipCount = (page - 1) * this.maxResultCount;
  };
}
